import { marketingAdministratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { campaignPageConfig } from "./campaignPageConfig";
import { campaignRelatedTableActions } from "./campaignRelatedTableActions";

export const campaignRecordDefinition: RecordDefinition = {
  path: "/reporting-campaign",
  entityName: "campaign",
  listRoute: "/reporting-campaigns",
  backTitle: "Back to reporting campaigns",
  allowedRoles: marketingAdministratorRoles,
  config: campaignPageConfig,
  relatedTableActions: campaignRelatedTableActions,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Reporting Campaign",
    newRecordTitle: "New Reporting Campaign",
  },
};
